import service from '@/store/services/licence-freeing-service';

export default {
    namespaced: true,
    state: {
        device_data: {
            id: null,
            type: "devices",
            cashRegisters: [{
                unique_number: null
            }],
            cashRegister: {
                unique_number: null,
                mf_registration_number: null
            },
        },
        unique_number: '',
        reason_data: null,
        consent_checkboxes: [false, false, false, false, false],
        cashRegisterStatus: {}
    },
    getters: {
        device_data: state => state.device_data,
        unique_number: state => state.unique_number,
        reason_data: state => state.reason_data,
        consent_checkboxes: state => state.consent_checkboxes,
        cashRegisterStatus: state => state.cashRegisterStatus,
    },
    mutations: {
        set_device: (state, payload) => {
            state.device_data = payload
        },
        set_unique_number: (state, payload) => {
            state.unique_number = payload
        },
        set_reason: (state, payload) => {
            state.reason_data = payload
        },
        set_consent_checkboxes: (state, payload) => {
            state.consent_checkboxes = payload
        },
        SET_RESOURCE: (state, cashRegisterStatus) => {
            state.cashRegisterStatus = cashRegisterStatus;
        },
    },
    actions: {
        add({ commit, dispatch }, params) {
            return service.add(params)
                .then((cashRegisterStatus) => { commit('SET_RESOURCE', cashRegisterStatus); });
        },
    }
}